import type { IconNode } from '../types';

/**
 * @name calendar-arrow-left
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMnYzIiAvPgogIDxwYXRoIGQ9Ik0yMSA5SDMiIC8+CiAgPHBhdGggZD0iTTMgMTIuMzRWNWEyIDIgMCAwMTItMmgxNGEyIDIgMCAwMTIgMnYxNGEyIDIgMCAwMS0yIDJoLTcuMzUiIC8+CiAgPHBhdGggZD0iTTMgMThoNiIgLz4KICA8cGF0aCBkPSJtNiAyMS0zLTMgMy0zIiAvPgogIDxwYXRoIGQ9Ik04IDJ2MyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/calendar-arrow-left
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CalendarArrowLeft: IconNode = [
  ['path', { d: 'M16 2v3' }],
  ['path', { d: 'M21 9H3' }],
  ['path', { d: 'M3 12.34V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2h-7.35' }],
  ['path', { d: 'M3 18h6' }],
  ['path', { d: 'm6 21-3-3 3-3' }],
  ['path', { d: 'M8 2v3' }],
];

export default CalendarArrowLeft;
